export const aboutData = {
    title: "Who I am",
    description1: "My name is Sudhanshu. I'm a Software Developer and ML Enthusiast.",
    description2: "I am currently in my final year persuing B.E. in ECE from BITS-Pilani, Hyderabad Campus. I love problem solving and analytical thinking and I'm actively looking for SDE roles.",
    image: 1
}